const uiDefaultConfig = {
  palette: {
    primary: '#1976d2',
    secondary: '#9c27b0',
    success: '#2e7d32',
    info: '#0288d1',
    warning: '#ed6c02',
    error: '#d32f2f',
    textPrimary: '#111827',
    textSecondary: '#6b7280',
    backgroundPaper: '#ffffff',
    backgroundDefault: '#f4f6f8',
    actionHover: '#f5f5f5',
    borderSubtle: '#e5e7eb',
    divider: '#e5e7eb',
  },
  gradients: {
    primary: ['#42a5f5', '#1e88e5'],
    success: ['#66bb6a', '#388e3c'],
    warning: ['#ffb74d', '#f57c00'],
  },
  components: {
    newUsersPage: {
      countBox: {
        background: '#1976d2',
        text: '#ffffff',
      },
    },
    learningPathway: {
      nestedRowBg: '#fafafa',
      textMuted: '#999',
      textLight: '#777',
      borderLight: '#eee',
      shadowSubtle: 'rgba(0,0,0,0.05)',
      shadowInset: 'rgba(0,0,0,0.02)'
    },
    analysisPage: {
      rankColors: {
        1: '#FFD700',
        2: '#C0C0C0',
        3: '#CD7F32',
        4: '#3CB371',
        5: '#F08080',
      },
      tickFill: '#555555',
    },
    userAnalysisPopup: {
      headerText: '#ffffff',
      closeButtonText: '#ffffff',
      closeButtonHover: 'rgba(255, 255, 255, 0.1)',
      alternatingRowBg: 'rgba(0, 0, 0, 0.02)',
    },
    subjectAnalysisPage: {
      chart: {
        scoreFill: '#ADD8E6',
        scoreStroke: '#4682B4',
        streakStroke: '#39FF14',
      },
    },
    loginPage: {
      background: 'linear-gradient(135deg, #119cd8 0%, #262262 100%)',
      cardBackground: '#ffffff',
      titleColor: '#111827',
      subtitleColor: '#6b7280',
      inputBackground: '#f9fafb',
      inputBorder: '#e5e7eb',
      inputFocusBorder: '#1976d2',
      iconColor: '#000000',
      buttonText: '#ffffff',
      cardShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
      buttonShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      buttonHoverShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      buttonHoverFilter: 'brightness(1.1)',
    },
    privilegeListPage: {
      card: {
        hoverShadow: 6,
        hoverTransform: 'translateY(-2px)',
      },
      chip: {
        borderRadius: '4px',
        fontWeight: 600,
      },
    },
    apiTelemetryPage: {
      metrics: {
        rps: '#2563eb',
        tpm: '#4f46e5',
        avg: '#0284c7',
        p90: '#d97706',
        p95: '#dc2626',
        success: '#059669',
        error: '#dc2626'
      },
      titleGradient: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 50%, #2563eb 100%)',
      historyButton: {
        bg: 'linear-gradient(135deg, #4f46e5 0%, #3b82f6 100%)',
        hoverBg: 'linear-gradient(135deg, #4338ca 0%, #2563eb 100%)',
        text: '#ffffff',
        shadow: '0 4px 12px rgba(79, 70, 229, 0.25)',
        hoverShadow: '0 6px 16px rgba(79, 70, 229, 0.35)'
      },
      tableHeader: {
        bg: '#f8fafc',
        color: '#475569',
        borderBottom: '#e2e8f0',
        activeSort: '#2563eb'
      },
      tableRow: {
        brightBg: '#ffffff',
        fadeBg: '#f8fafc',
        hoverBg: '#eff6ff',
        borderColor: '#f1f5f9'
      },
      methodTag: {
        bg: '#eff6ff',
        color: '#2563eb',
        border: '#dbeafe'
      },
      pathParam: {
        color: '#d97706',
        bg: 'rgba(245, 158, 11, 0.12)'
      },
      copyButton: {
        copiedColor: '#059669',
        copiedBg: '#ecfdf5',
        defaultColor: '#94a3b8',
        hoverColor: '#2563eb',
        hoverBg: '#eff6ff'
      },
      filterChips: {
        all: {
          activeBg: '#1e293b',
          activeColor: '#ffffff',
          activeBorder: '#1e293b',
          activeHover: '#0f172a',
          inactiveBg: 'rgba(255, 255, 255, 0.85)',
          inactiveColor: '#64748b',
          inactiveBorder: '#e2e8f0',
          inactiveHover: '#f1f5f9'
        },
        errors: {
          activeBg: '#dc2626',
          activeColor: '#ffffff',
          activeBorder: '#dc2626',
          activeHover: '#b91c1c',
          inactiveBg: 'rgba(255, 255, 255, 0.85)',
          inactiveColor: '#dc2626',
          inactiveBorder: '#fecaca',
          inactiveHover: '#fef2f2'
        },
        active: {
          activeBg: '#2563eb',
          activeColor: '#ffffff',
          activeBorder: '#2563eb',
          activeHover: '#1d4ed8',
          inactiveBg: 'rgba(255, 255, 255, 0.85)',
          inactiveColor: '#2563eb',
          inactiveBorder: '#dbeafe',
          inactiveHover: '#eff6ff'
        },
        slow: {
          activeBg: '#d97706',
          activeColor: '#ffffff',
          activeBorder: '#d97706',
          activeHover: '#b45309',
          inactiveBg: 'rgba(255, 255, 255, 0.85)',
          inactiveColor: '#d97706',
          inactiveBorder: '#fde68a',
          inactiveHover: '#fffbeb'
        }
      },
      latencyBadges: {
        optimal: { color: '#059669', bg: '#ecfdf5', border: '#a7f3d0' },
        good: { color: '#0284c7', bg: '#f0f9ff', border: '#bae6fd' },
        moderate: { color: '#d97706', bg: '#fffbeb', border: '#fde68a' },
        slow: { color: '#dc2626', bg: '#fef2f2', border: '#fecaca' }
      },
      rpsBadge: {
        bg: '#eff6ff',
        border: '#bfdbfe',
        color: '#1d4ed8',
        dot: '#2563eb'
      },
      healthStatus: {
        optimal: '#059669',
        warning: '#d97706',
        danger: '#dc2626',
        errorBar: '#ef4444',
        trackBg: '#f1f5f9',
        textMuted: '#94a3b8'
      },
      historyModal: {
        headerBg: '#fafafa',
        filterBg: '#f8fafc',
        border: '#e2e8f0',
        peakBadgeBg: 'rgba(37, 99, 235, 0.1)',
        peakBadgeBorder: 'rgba(37, 99, 235, 0.2)',
        peakBadgeColor: '#2563eb',
        gridLine: '#f1f5f9',
        axisColor: '#64748b'
      },
      pagination: {
        bg: 'rgba(248, 250, 252, 0.7)',
        border: '#e2e8f0',
        labelColor: '#64748b',
        buttonColor: '#475569',
        buttonHoverBg: '#e2e8f0'
      }
    },
    "addProductPage": {
      "avatarPrimary": {
        "bg": '#e3f2fd',
        "color": '#1976d2'
      },
      "avatarSuccess": {
        "bg": '#e8f5e9',
        "color": '#2e7d32'
      },
      "avatarWarning": {
        "bg": '#fff3e0',
        "color": '#ed6c02'
      },
      "livePreviewBg": 'rgba(25, 118, 210, 0.04)',
      "sectionBorderRadius": 3,
      "formSpacing": 4
    },
     "editProductPage": {
      "avatarPrimary": {
        "bg": '#e3f2fd',
        "color": '#1976d2'
      },
      "avatarSuccess": {
        "bg": '#e8f5e9',
        "color": '#2e7d32'
      },
      "avatarWarning": {
        "bg": '#fff3e0',
        "color": '#ed6c02'
      },
      "livePreviewBg": 'rgba(25, 118, 210, 0.04)',
      "sectionBorderRadius": 3,
      "formSpacing": 4
    },
    "faqSection": {
      "questionColor": "#1976d2",
      "answerColor": "#4b5563",
      "headerBg": "#f8fafc",
      "sourceBg": "#f8fafc",
      "sourceText": "#0f172a",
      "borderColor": "#e2e8f0",
      "badgeBg": "#f1f5f9",
      "badgeText": "#475569",
      "templateBorder": "#e0e0e0",
      "editorBodyColor": "#2d3748",
      "buttonBg": "#ffffff"
    },
    "productsPage": {
      "stats": {
        "total": "#1976d2",
        "sub": "#2e7d32",
        "qb": "#ed6c02",
        "book": "#9c27b0"
      },
      "filterBg": "rgba(255, 255, 255, 0.6)",
      "cardHoverShadow": 6,
      "cardHoverTransform": "translateY(-4px)"
    },
    "ordersPage": {
      "stats": {
        "primaryBg": "#e3f2fd",
        "primaryIcon": "#1976d2",
        "successBg": "#e8f5e9",
        "successIcon": "#2e7d32",
        "warningBg": "#fff3e0",
        "warningIcon": "#ed6c02",
        "darkBg": "#f1f5f9",
        "darkIcon": "#0f172a"
      },
      "status": {
        "paid": "#1976d2",
        "failed": "#d32f2f",
        "created": "#ed6c02",
        "pending": "#0f172a",
        "unknown": "#757575"
      },
      "headerIconBg": "#1976d2",
      "headerIconColor": "#ffffff"
    },
    "mockTestManagementPage": {
      "avatarActive": {
        "bg": "#e8f5e9",
        "color": "#2e7d32"
      },
      "avatarExpired": {
        "bg": "#ffebee",
        "color": "#d32f2f"
      },
      "progressColors": {
        "high": "#2e7d32",
        "medium": "#ed6c02",
        "low": "#d32f2f"
      },
      "groupLicenseChip": {
        "bg": "#f3e5f5",
        "color": "#7b1fa2"
      },
      "individualChip": {
        "bg": "#e3f2fd",
        "color": "#1565c0"
      }
    },
    "studentsManagementPage": {
      "stats": {
        "totalBg": "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
        "activeBg": "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
        "newBg": "linear-gradient(135deg, #a855f7 0%, #9333ea 100%)"
      },
      "addButton": {
        "bg": "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
        "hoverBg": "linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%)"
      }
    },
    "studentDetailsPreviewPage": {
      "headerColor": "#1e3a8a",
      "formBorderColor": "#d1d5db"
    },
    "notificationManagementPage": {
      "card": {
        "border": "#e2e8f0",
        "shadow": "0 4px 20px rgba(0, 0, 0, 0.04)"
      },
      "tableHeader": {
        "color": "#475569",
        "bg": "#f8fafc",
        "borderBottom": "#e2e8f0"
      },
      "tableRow": {
        "hoverBg": "#f8fafc",
        "idColor": "#64748b",
        "idBg": "#f1f5f9",
        "titleColor": "#0f172a",
        "bodyColor": "#64748b",
        "cronColor": "#334155",
        "cronBg": "#f8fafc",
        "cronBorder": "#e2e8f0"
      },
      "typeChips": {
        "DAILY_REMINDER": { "bg": "#eff6ff", "color": "#2563eb", "border": "#bfdbfe" },
        "WEEKLY_RECAP": { "bg": "#f0fdf4", "color": "#16a34a", "border": "#bbf7d0" },
        "EXAM_READINESS": { "bg": "#fff7ed", "color": "#ea580c", "border": "#fed7aa" },
        "PAID_TEST": { "bg": "#ecfeff", "color": "#0891b2", "border": "#a5f3fc" },
        "STREAK_ALERT": { "bg": "#fdf4ff", "color": "#c026d3", "border": "#f5d0fe" },
        "CONTENT_UPDATE": { "bg": "#ecfdf5", "color": "#059669", "border": "#a7f3d0" },
        "INACTIVE_USER": { "bg": "#fef2f2", "color": "#dc2626", "border": "#fecaca" },
        "NEW_TEST_ASSIGNED": { "bg": "#f0f9ff", "color": "#0284c7", "border": "#bae6fd" },
        "LEADERBOARD_ALERT": { "bg": "#fefce8", "color": "#ca8a04", "border": "#fef08a" },
        "WEEKLY_PERFORMANCE": { "bg": "#faf5ff", "color": "#9333ea", "border": "#e9d5ff" },
        "default": { "bg": "#f1f5f9", "color": "#475569", "border": "#cbd5e1" }
      },
      "modeChips": {
        "IMMEDIATE": { "bg": "#e0f2fe", "color": "#0369a1", "border": "#93c5fd" },
        "SCHEDULED": { "bg": "#f3e8ff", "color": "#7e22ce", "border": "#d8b4fe" }
      },
      "actions": {
        "editColor": "#2563eb",
        "editBg": "#eff6ff",
        "editHoverBg": "#dbeafe",
        "deleteColor": "#ef4444",
        "deleteBg": "#fef2f2",
        "deleteHoverBg": "#fee2e2"
      },
      "pagination": {
        "borderTop": "#e2e8f0",
        "color": "#64748b"
      }
    }
  },
};

export default uiDefaultConfig;